import { useState, useContext } from "react";
import UserContext from "../../contexts/userContext";

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { WizardVariable } from "./1-1-1_WizardVariable";

import { focusOnQueryInput } from "../../utils";
import "../../styles/DocumentList.css"

export const Wizard = () => {
    const { userContext, addMessage } = useContext(UserContext);
    const [ commandTemplateId, setCommandTemplateId ] = useState();

    if (userContext.document === undefined || userContext.conversation === undefined || userContext.templates === undefined) {
        return;
    }

    const commandTemplates = userContext.templates.command.filter(template => {
        return  template.documents === undefined || 
                template.documents.length === 0 ||
                template.documents.indexOf(userContext.document.documentid) > -1
    });

    const executeCommandTemplate = (commandTemplate) => {
        let humanInput = commandTemplate.wizard.humanInput;
        const promptTemplate = commandTemplate.template;
        let clientResolvedPromptTemplate = commandTemplate.template;
        
        const variables = commandTemplate.wizard.variables || [];
        for (let i=0; i<variables.length; i++) {
            const variableValue = document.getElementById(`variableInput${i}`).value;
            humanInput = humanInput.replaceAll(`{{VARIABLE_${i}}}`, variableValue);
            clientResolvedPromptTemplate = clientResolvedPromptTemplate.replaceAll(`{{VARIABLE_${i}}}`, variableValue);
        }
        
        document.getElementById('humanInputTextarea').disabled = true;
        document.getElementById('submitQueryButton').disabled = true;
        
        addMessage([{
            type: 'human',
            content: humanInput,
            humanInput: humanInput,
            promptTemplate: promptTemplate,
            clientResolvedPromptTemplate: clientResolvedPromptTemplate,
            isCommand: true,
            created: new Date().toISOString().slice(0,-1)
        },{
            type: 'ai',
            content: 'STREAMING_PLACEHOLDER',
            humanInput: humanInput,
            promptTemplate: promptTemplate,
            clientResolvedPromptTemplate: clientResolvedPromptTemplate,
            isCommand: true,
            created: new Date().toISOString().slice(0,-1)
        }]);
    }
    
    if (commandTemplateId === 0) {
        focusOnQueryInput();
        return;
    } else if (commandTemplateId !== undefined) {
        const commandTemplate = commandTemplates[commandTemplateId];
        const wizard = commandTemplate.wizard;
        wizard.variables = wizard.variables || [];
        
        return (
            <Modal show={true} size="xl">
                <Modal.Header 
                    className="text-muted pt-2 pb-2"
                    style={{backgroundColor:"rgba(33, 37, 41, 0.03)"}}
                >
                    <Modal.Title>
                        <i className="bi-magic a8-orange mx-2" />
                        <span
                            className="a8-orange"
                            style={{fontFamily: "PP Neue Montreal"}}
                        >
                            {wizard.title}
                        </span>
                        
                        <div 
                            className="a8-gray"
                            style={{
                                fontSize: ".65em",
                                fontStyle: "italic",
                                fontWeight: "normal",
                                paddingLeft: "2.5rem"
                            }}
                        >
                            {wizard.description}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4 ">
                    {wizard.variables.map((variable, i) => {
                        return (
                            <div>
                                <WizardVariable 
                                    key={`${commandTemplate.id}-${i}`}
                                    i={i}
                                    label={variable.label}
                                    defaultValue={variable.defaultValue}
                                    displayAs={variable.displayAs}
                                    displayParams={variable.displayParams}
                                />
                            </div>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer style={{backgroundColor:"rgba(33, 37, 41, 0.03)"}}>
                    <Button
                        variant="secondary"
                        className="a8-gray-background mx-1"
                        onClick={() => setCommandTemplateId(undefined)}
                    >
                        <i className="bi-arrow-left" /> Back 
                    </Button>
                    <Button
                        variant="primary"
                        className="a8-dark-blue-background mx-2"
                        onClick={() => executeCommandTemplate(commandTemplate)}
                    >
                        Next <i className="bi-arrow-right" />
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    } else {
        return (
            <div id="wizard">
                <Row xs={1} sm={2} md={2} lg={4} className="g-4 docCardRow">
                    {commandTemplates.map((commandTemplate, i) => {
                        return (
                            <Col key={i}>
                                <Card
                                    className="m-2 docCard no-text-decoration"
                                    id={commandTemplate.id}
                                    onClick={() => setCommandTemplateId(i)}
                                >
                                    <Card.Header style={{height: "4rem"}} >
                                        {i===0 ? 
                                            <i className="bi-slash-square pe-1" /> :
                                            <i className="bi-magic pe-1" />
                                        }
                                        {commandTemplate.wizard.title}
                                    </Card.Header>
                                    <Card.Body style={{height: "8rem"}}>
                                        <div className="docCardBody">
                                            {commandTemplate.wizard.description}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>
            </div>
        )
    }
};

